import React from 'react'
import { GetTodayConditionInputDetailDto } from '../../../dataAccess/webApi/dto/reservationsDto'
import { GContainer, RowSpacerGItem } from '../common/grids'
import { InfoCard } from '../common/infoCard'
import { LabelGItem, ValueGItem } from '../common/reservationDetail/reservationDetailParts'
import { translate } from '../../../i18n'
import { formatHm, formatYmdWeek, formatYmd } from '../../../utils/dateUtil'

type ReservationInfoAreaProps = {
  reservationInfo: GetTodayConditionInputDetailDto['reservationInfo']
}

// その他セクション
const ReservationInfoArea: React.FC<ReservationInfoAreaProps> = (props) => {
  const { reservationInfo } = props

  return (
    <InfoCard>
      <GContainer>
        {/* 施設名 */}
        <LabelGItem>{translate('facilityReservationTodayConditionInput.view.facilityName')}</LabelGItem>
        <ValueGItem>{reservationInfo.facilityName}</ValueGItem>

        <RowSpacerGItem />

        {/* ご利用目的 */}
        {reservationInfo.displayNameForCitizenIrregular && (
          <>
            <LabelGItem>{translate('facilityReservationTodayConditionInput.view.useReason')}</LabelGItem>
            <ValueGItem>{reservationInfo.displayNameForCitizenIrregular}</ValueGItem>
          </>
        )}
        {/* 利用日 */}
        <LabelGItem>{translate('facilityReservationTodayConditionInput.view.usageDate')}</LabelGItem>
        <ValueGItem>{formatYmdWeek(new Date(reservationInfo.usageDate))}</ValueGItem>
        {/* 利用時間 */}
        <LabelGItem>{translate('facilityReservationTodayConditionInput.view.usageDateTime')}</LabelGItem>
        <ValueGItem>{`${formatHm(new Date(reservationInfo.useFromDatetime))}～${formatHm(new Date(reservationInfo.useToDatetime))}`}</ValueGItem>

        <RowSpacerGItem />

        {/* 保護者 */}
        <LabelGItem>{translate('facilityReservationTodayConditionInput.view.userName')}</LabelGItem>
        <ValueGItem>{reservationInfo.userName}</ValueGItem>
        {/* フリガナ */}
        <LabelGItem>{translate('facilityReservationTodayConditionInput.view.userKana')}</LabelGItem>
        <ValueGItem>{reservationInfo.userKana}</ValueGItem>
        {/* お子さま */}
        <LabelGItem>{translate('facilityReservationTodayConditionInput.view.childName')}</LabelGItem>
        <ValueGItem>{reservationInfo.childName}</ValueGItem>
        {/* フリガナ */}
        <LabelGItem>{translate('facilityReservationTodayConditionInput.view.childKana')}</LabelGItem>
        <ValueGItem>{reservationInfo.childKana}</ValueGItem>
        {/* 生年月日 */}
        <LabelGItem>{translate('facilityReservationTodayConditionInput.view.childBirthday')}</LabelGItem>
        <ValueGItem>{formatYmd(new Date(reservationInfo.childBirthday))}</ValueGItem>
      </GContainer>
    </InfoCard>
  )
}

export default ReservationInfoArea
